import { render, staticRenderFns } from "./EditFormCourse.html?vue&type=template&id=68a070a0&scoped=true&"
import script from "./EditFormCourse.vue?vue&type=script&lang=js&"
export * from "./EditFormCourse.vue?vue&type=script&lang=js&"
import style0 from "./EditFormCourse.scss?vue&type=style&index=0&id=68a070a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a070a0",
  null
  
)

export default component.exports